import { Box, Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, LinearProgress } from "@mui/material";
import { cloneDeep } from "lodash";
import React, { useEffect, useState } from "react";
import { IMaterial, IMaterialItem, IMaterialNote } from "../../interfaces";
import { LocationFormSection } from "../MaterialInputDialog/LocationFormSection";


interface ILocationDialog {
    open: boolean,
    handleClose: (confirm: boolean) => void,
    materials: IMaterial[],
    onUpdate: (material: IMaterial) => void
}

export const LocationDialog: React.FC<ILocationDialog> = ({
    open,
    handleClose,
    materials,
    onUpdate,
    ...props
}: ILocationDialog) => {

    const [model, setModel] = useState<IMaterial | null>(null);
    const [arrivalOnly, setArrivalOnly] = useState(false);
    const [loading, setLoading] = useState(false);

    const onUpdateSelection = async (property: string, opt: IMaterialItem | IMaterialItem[] | IMaterialNote[] | number | string | string[] | null) => {
        return new Promise((resolve, reject) => {
            if (opt !== null) {
                let m: any = cloneDeep(model);
                m[property] = opt;
                setModel(m);
            }
            resolve(undefined);
        })
    }

    const onApply = async () => {
        setLoading(true);

        for (const material of materials) {
            if (!arrivalOnly) {
                material.site = model?.site;
                material.warehouse = model?.warehouse;
                material.rack = model?.rack;
                material.row = model?.row;
                material.pallet = model?.pallet;
            }

            material.arrivalDate = model?.arrivalDate;

            try {
                await onUpdate(material);
                console.log("material updated" + material.materialId);
            } catch (error) {
                console.log("Error updating material:", error);
                // Handle the error if needed.
            }
        }

        console.log("All materials updated");
        handleClose(true);

    };

    useEffect(() => {
        if (model === null && materials.length > 0)
            setModel(materials[0])
    }, [materials])

    useEffect(() => {
        setLoading(false);
    }, [open])

    return <Dialog
        open={open}
        onClose={handleClose}
    >
        <DialogTitle>{`Update Materials (${materials.length})`}</DialogTitle>

        <DialogContent>

            {loading ? <LinearProgress /> : (model !== null &&

                <>

                    <LocationFormSection
                        material={model}
                        onUpdate={onUpdateSelection}
                        arrivalOnly={arrivalOnly}
                    />
                </>
            )}

        </DialogContent>
        <DialogActions>


            <Box display="flex" flex={1} paddingLeft="1em">
                <FormControlLabel control={
                    <Checkbox
                        size="small"
                        checked={arrivalOnly}
                        onChange={() => setArrivalOnly(!arrivalOnly)}
                        disabled={loading}
                    />}
                    label={<small><i>Arrival date only</i></small>}
                />
            </Box>
            <Button
                color="warning"
                onClick={() => handleClose(false)}
                disabled={loading}
            >Cancel</Button>
            <Button
                color="primary"
                onClick={onApply}
                disabled={loading}
            >{`Update (${materials.length})`}</Button>
        </DialogActions>
    </Dialog>
}